
<style lang="scss">
    .selectupload .ivu-select-dropdown{
        width:326px !important;
    }
</style>
<template>
    <vForm :label-width="120" inline class="selectupload">
        <compFormEdit
            ref="formdata"
            class="margin-10"
            v-if="getBase&&getBase.length"
            :formdata="getBase"
            v-model="formData"
        ></compFormEdit>
        <compMutiUpload ref="mutiupload" v-bind="getFileProps" @on-cancel="close" @on-success="success" :warningtitle="warningtitle"></compMutiUpload>
        
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";

import { HttpgetFileName,HttpUpdateAttach,HttpUpdateAttachOne } from "@/service/proddevelop";

export default {
    props:{
        srcLabelid: Number,
        name: String, 
        formdata: Array,
        actionurl: String,
        downrul: String,
        warningtitle: String, 
        localurl:Boolean,
        factory:Number,
        optionlist:Array,
    },
    data(){
        return {
            formData:{isUpdate:0,companyName:''}
        }
    },
    components: {
        compFormEdit: () => import("@components/templates/formedit"),
		compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    created(){
        this.formData.companyName = this.optionlist[0].companyName
    },
    computed: {
        getBase(){
            return this.formdata
        },
        getFileProps() {
			return {
				action: this.actionurl,
                name: this.name,
                multiple: true,
				data: {
                    srcLabel: this.srcLabelid || 0,
                    model: 'pd_preselection',
                    type: 'other',
                },
                beforeUpload: (fileLists)=>{
                    if (fileLists.length > 21) {
                        this.$VMessage.error('附件数量超过20，请打包后上传');
                        return false;
                    }
                    let datalist = [];
                    fileLists.map(item=>{
                        let json = {
                            fileName:item.name
                        }
                        datalist.push(json)
                    })
                    if(this.factory === 1 ){
                        return true
                    }else{
                        return HttpgetFileName({
                            attachList:datalist
                        }).then(res=>{
                            return true
                        },err=>{
                            this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                            this.$refs.mutiupload.fileList = []
                            return false
                        })
                    }
                }
			}
		},
    },
    methods: {
        close(){
            this.$emit('on-close')
        },
        success(res){
            // console.log(res,'434343434343')
            let datalist = [], itemlist = [];
            res.items.map(json=>{
                let jsonone = {
                    fileName:json.attachTitle,
                    fileValue:JSON.stringify(json)
                }
                let itemone = {
                    fileValue:JSON.stringify(json)
                }
                itemlist.push(itemone);
                datalist.push(jsonone);
            })
            if(this.factory === 1){
                HttpUpdateAttachOne({
                    orgId:global.SYSID,
                    companyName:this.formData.companyName,
                    preselectionId:this.srcLabelid,
                    attachList:itemlist
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.close();
                    this.$emit('on-update');
                },err=>{
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                })
            }else{
                HttpUpdateAttach({
                    orgId:global.SYSID,
                    isUpdate:this.formData.isUpdate,
                    attachList:datalist,
                }).then(res=>{
                    this.$VMessage.success(res.message);
                    this.close();
                    this.$emit('on-update');
                },err=>{
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                })
            }
        }
    }
}
</script>